module.exports = __webpack_public_path__ + "static/site_logo-dd95a305fa163ea3d43cc65b7fc9d4cd.png";